import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'toMiles',
})
export class MetresToMilesPipe implements PipeTransform {
  constructor() {}

  transform(v: number, digits = 2, noValue = ''): string {
    if (v == null || typeof v == 'undefined') {
      return noValue;
    }

    return Math.round(parseFloat((v * 0.000621371192).toFixed(digits))).toString();
  }
}
